export default "/static/images/build_middle_5.png?99720677e1dfc561005a2616a033d382";